<template>
  <div id="contents">
    <div class="inner detail-top user-preview">
      <div class="clear" />
      <ul
        class="mt30 fs13 detail-menu"
        data-test="preview-tab"
      >
        <a><li>募集情報</li></a>
        <span><li class="active">面接情報</li></span>
      </ul>
      <div class="company-area">
        <h1 class="fs16 hd-type-02 company-title">
          {{ companyName }}（サンプル［ここに実際の募集職種名が入ります］）の面接対策・選考情報
        </h1>
      </div>
      <div class="contents-inner clearfix mb30">
        <section class="mlr10">
          <div>
            <h2
              class="fs14 fwB"
              style="line-height: 1.6;"
            >
              {{ companyName }}「サンプル［ここに実際の募集職種名が入ります］」の面接対策や選考情報が調べられ、企業研究になるページです。中途採用の流れや面接時に質問されやすい項目などを事前に確認することで面接内容について対策が出来ます。
            </h2>
          </div>
        </section>
        <section class="pt20 mlr10">
          <div class="hd-type-03">
            <h3 id="description">
              応募職種概要
            </h3>
          </div>
          <article>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>会社名</h4>
              </div>
              <div class="detail-right">
                <p
                  data-test="company-name"
                  v-text="companyName"
                />
              </div>
            </div>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>募集職種名</h4>
              </div>
              <div class="detail-right">
                <p>サンプル［ここに実際の募集職種名が入ります］</p>
              </div>
            </div>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>書類選考</h4>
              </div>
              <div class="detail-right">
                <p
                  data-test="paper-screening-label"
                  v-text="paperScreeningLabel"
                />
                <p
                  v-if="jobInterview.paperScreeningRemarks"
                  class="mt15"
                  data-test="paper-screening-remarks"
                  v-text="jobInterview.paperScreeningRemarks"
                />
              </div>
            </div>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>適性検査の有無</h4>
              </div>
              <div class="detail-right">
                <p
                  data-test="spi-label"
                  v-text="spiLabel"
                />
                <p
                  v-if="jobInterview.spiTestRemarks"
                  class="mt15"
                  data-test="spi-remarks"
                  v-text="jobInterview.spiTestRemarks"
                />
              </div>
            </div>
          </article>
        </section>

        <section class="mlr10 mt30">
          <div class="hd-type-03">
            <h3 id="require">
              面接の選考情報
            </h3>
          </div>
          <section>
            <div>
              <p
                class="fs13 mt20 mb20"
                style="line-height: 1.6;"
                data-test="interview-information-description"
              >
                1次面接や役員面接、最終面接など、{{ companyName }}の中途採用面接について紹介します。
              </p>
            </div>
          </section>

          <article>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>面接内容</h4>
              </div>
              <div class="detail-right">
                <p
                  data-test="content"
                  v-text="jobInterview.content"
                />
              </div>
            </div>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>面接官について</h4>
              </div>
              <div class="detail-right">
                <template v-for="(interviewer, i) in jobInterview.interviewers">
                  <p
                    v-if="jobInterview.interviewers.length > 1"
                    :key="`interviewer-label-${interviewer.no}`"
                    class="stage fwB"
                    :class="{ mt15: i > 0}"
                    :data-test="`interviewer-label-${i}`"
                    v-text="`${interviewer.no}次選考`"
                  />
                  <template v-if="isSelectionType(interviewer)">
                    <p
                      :key="`interviewer-detail-${interviewer.no}`"
                      :data-test="`interviewer-detail-${i}`"
                      v-text="getInterviewLabel(interviewer)"
                    />
                    <dl
                      v-if="interviewer.remarksOrFreeText"
                      :key="`interviewer-remarks-${interviewer.no}`"
                      class="bg-blue-box p15 mt10"
                      :data-test="`interviewer-remarks-${i}`"
                    >
                      <dd>{{ interviewer.remarksOrFreeText }}</dd>
                    </dl>
                  </template>
                  <template v-else>
                    <p
                      :key="`interviewer-remarks-${interviewer.no}`"
                      :data-test="`interviewer-remarks-${i}`"
                      v-text="interviewer.remarksOrFreeText "
                    />
                  </template>
                </template>
              </div>
            </div>
            <div
              v-if="requiredTimeLabel || jobInterview.requiredTimeRemarks"
              class="details clearfix"
              data-test="required-time"
            >
              <div class="detail-left">
                <h4>所要時間</h4>
              </div>
              <div class="detail-right">
                <p
                  v-if="requiredTimeLabel"
                  class="opportunity mb15"
                  data-test="required-time-label"
                  v-text="requiredTimeLabel"
                />
                <p
                  v-if="jobInterview.requiredTimeRemarks"
                  data-test="required-time-remarks"
                  v-text="jobInterview.requiredTimeRemarks"
                />
              </div>
            </div>
            <div
              v-if="clothLabel || jobInterview.clothRemarks"
              class="details clearfix"
              data-test="cloth"
            >
              <div class="detail-left">
                <h4>面接時の服装/持ち物</h4>
              </div>
              <div class="detail-right">
                <p
                  v-if="clothLabel"
                  class="fashion mb15"
                  data-test="cloth-label"
                  v-text="clothLabel"
                />
                <p
                  v-if="jobInterview.clothRemarks"
                  data-test="cloth-renarks"
                  v-text="jobInterview.clothRemarks"
                />
              </div>
            </div>
          </article>
        </section>

        <section class="mlr10 mt30">
          <div class="hd-type-03">
            <h3
              id="about"
              data-test="importance-point-title"
            >
              {{ companyName }}の面接対策ポイント
            </h3>
          </div>
          <section>
            <div>
              <p
                class="fs13 mt20 mb20"
                style="line-height: 1.6;"
                data-test="importance-point-description"
              >
                コミュニケーション能力、仕事への意欲など、{{ companyName }}が面接時に重要視しているポイントが分かります。
              </p>

              <div class="clearfix">
                <div class="rating-block fll">
                  <div class="rating-left">
                    <ul>
                      <interview-preview-importance-point
                        label="business"
                        :value="jobInterview.businessManner"
                      />
                      <interview-preview-importance-point
                        label="communication"
                        :value="jobInterview.communicationAbility"
                      />
                    </ul>
                  </div>
                </div>
                <div class="rating-block flr">
                  <div class="rating-right">
                    <ul>
                      <interview-preview-importance-point
                        label="skill"
                        :value="jobInterview.skill"
                      />
                      <interview-preview-importance-point
                        label="ｍotivation"
                        :value="jobInterview.motivation"
                      />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>

        <section class="mlr10 mt30">
          <div class="hd-type-03">
            <h3 id="oldies">
              過去の中途面接について
            </h3>
          </div>
          <section>
            <div>
              <p
                class="fs13 mt20 mb20"
                style="line-height: 1.6;"
                data-test="about-interview-description"
              >
                {{ companyName }}の採用面接の過去の質問例などを紹介します。
              </p>
            </div>
          </section>
          <article>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>過去の面接であった質問</h4>
              </div>
              <div class="detail-right">
                <template v-for="index in [1,2,3]">
                  <template v-if="jobInterview[`question${index}`]">
                    <span
                      v-if="existsQuestionTwoOrThree"
                      :key="`label-${index}`"
                      :data-test="`question${index}-label`"
                      class="point fs12"
                    >質問例0{{ index }}</span>
                    <p
                      :key="index"
                      :data-test="`question${index}-text`"
                      v-text="jobInterview[`question${index}`]"
                    />
                  </template>
                </template>
              </div>
            </div>
            <div
              v-if="welcomeQuestionLabels.length > 0"
              class="details clearfix"
              data-test="welcome-questions"
            >
              <div class="detail-left">
                <h4>右記項目についての質問歓迎です</h4>
              </div>
              <div class="detail-right question-example">
                <ul class="question-example-ul">
                  <li
                    v-for="(item, i) in welcomeQuestionLabels"
                    :key="`welcome-question-${i}`"
                    class="question-example-li"
                    data-test="welcome-questions-item"
                    v-text="item.name"
                  />
                </ul>
              </div>
            </div>
          </article>
        </section>
        <section class="mlr10 viewpoints mt30">
          <h4
            class="fs14 fwB tc interview"
            data-test="message-title"
          >
            {{ companyName }}からのメッセージ
          </h4>
          <div class="fs13 p20 interview-row">
            <p
              data-test="message"
              v-text="jobInterview.message"
            />
          </div>
        </section>
        <section class="mlr10 mt30">
          <div class="hd-type-03">
            <h3 id="company">
              会社概要
            </h3>
          </div>
          <article>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>会社名</h4>
              </div>
              <div class="detail-right">
                <p
                  data-test="company-name-buttom"
                  v-text="companyName"
                />
              </div>
            </div>
            <div class="details clearfix">
              <div class="detail-left">
                <h4>企業HP</h4>
              </div>
              <div class="detail-right">
                <a>https://*******.jp［ここに実際の企業ホームページURLが入ります］</a>
              </div>
            </div>
          </article>
        </section>
        <div class="caution mb15 mlr10">
          <p class="fwB">
            この面接対策・選考情報ページは掲載スタート時の情報となります。<br>掲載企業の選考状況などにより、内容が変更となる場合もありますので、ご了承くださいませ。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/jobinterview/base" as *;
</style>

<script>
import InterviewPreviewImportancePoint from '@/components/atoms/InterviewPreviewImportancePoint.vue'
import { jobInterview } from '@/lib/labelValueMappings'

export default {
  components: {
    InterviewPreviewImportancePoint
  },
  data () {
    return {
      jobInterview: {},
      interviewOptions: jobInterview,
      company: {}
    }
  },
  computed: {
    companyName () {
      return this.company.displayName
    },
    paperScreeningLabel () {
      return this.getLabel(this.jobInterview.paperScreening)
    },
    spiLabel () {
      return this.getLabel(this.jobInterview.spiTest)
    },
    requiredTimeLabel () {
      return this.getLabel(this.jobInterview.requiredTime)
    },
    clothLabel () {
      return this.getLabel(this.jobInterview.cloth)
    },
    welcomeQuestionLabels () {
      const questions = this.jobInterview.welcomeQuestions ?? []
      return this.interviewOptions.welcomeQuestionsOptions
        .filter(option => questions.some(questionId => questionId === option.id))
    },
    existsQuestionTwoOrThree () {
      // 質問1は必須項目なので登録前提
      return !!this.jobInterview.question1 && (!!this.jobInterview.question2 || !!this.jobInterview.question3)
    }
  },
  created () {
    this.fetchInterview()
    this.fetchCompany()
  },
  methods: {
    fetchInterview () {
      this.$http.secured.get(`/interview/interviews/${this.$route.params.jobInterviewId}`)
        .then(response => {
          this.$set(this, 'jobInterview', response.data)
        })
    },
    fetchCompany () {
      // 別タブで開くため、storeの値を利用できず、企業情報を取得する
      this.$http.secured.get('/company')
        .then(response => {
          this.$set(this, 'company', response.data)
        })
    },
    getLabel (val) {
      return val ? val.name : ''
    },
    isSelectionType (val) {
      return val.selectionType.id === 1
    },
    getInterviewLabel (val) {
      return `${this.getLabel(val.gender)}/${this.getLabel(val.position)}/${this.getLabel(val.generation)}`
    }
  }
}
</script>
